export const requestTypesInDb = [{
  value: 'MyOffer'
},
{
  value: 'MyDocuments'
},
{
  value: 'MyRole'
},
{
  value: 'FileClaim'
},
{
  value: 'MyProjects'
},
{
  value: 'IdeaSuggestion'
},
{
  value: 'MySettings'
},
{
  value: 'MyTraining'
}];

export default class FakeUserCaseService {
  getUserRequestTypes() {
    return Promise.resolve(requestTypesInDb);
  }

  createUserRequest() {
    return Promise.resolve();
  }
}
